import Icon from '@mdi/react'
import { Font14, Font16 } from 'components/Typography'
import styled from 'styled-components'
import theme from 'theme_'

export const LincesesGroupHeadingRight = styled.div`
  display: flex;
  flex-direction: row;
  align-items: center;
`

export const LicensesGroupHeadingLeft = styled.div`
  display: flex;
  flex-direction: row;
  align-items: center;
`

export const LicensesGroupHeadingCount = styled.div`
  display: none;
  font-weight: 900;
  @media ${theme.devices.tablet} {
    display: block;
    ${Font14};
    color: ${theme.colors.otterWarmBlack};
    margin-right: 24px;
  }
`

export const LicensesGroupHeadingCountMobile = styled(
  LicensesGroupHeadingCount
)`
  display: block;
  @media ${theme.devices.tablet} {
    display: none;
  }
`

export const LicensesGroupHeadingDropdownIcon = styled(Icon)`
  width: 16px;
  height: 16px;
  color: ${theme.colors.horizonOrange};
  transition: all 0.2s ease;
  :hover {
    opacity: 0.8;
  }
`

export const LicensesGroupHeadingLicenseIcon = styled(Icon)`
  width: 24px;
  height: 24px;
  color: ${theme.colors.dolphinGrey};
`

export const LicensesGroupHeadingDescription = styled.div`
  display: flex;
  flex-direction: column;
  margin-left: 16px;
  gap: ${theme.spacing.tiny};
`

export const LicensesGroupHeadingLabel = styled.div`
  font-weight: normal;
  ${Font14};
  color: ${theme.colors.moreGrey};
`

export const LicensesGroupHeadingTitle = styled.div`
  font-weight: 900;
  ${Font16};
  color: ${theme.colors.otterWarmBlack};
`
